import { Component, OnChanges, ChangeDetectionStrategy, input } from '@angular/core';
import {IecLeadTime} from '../../../model/iec-lead-time';


@Component({
    selector: 'app-lead-time-row',
    templateUrl: './lead-time-row.component.html',
    styleUrls: ['./lead-time-row.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class LeadTimeRowComponent implements OnChanges {

  readonly entityLeadTime = input.required<IecLeadTime>();
  readonly configurationLeadTime = input.required<IecLeadTime>();
  validLeadTime!: boolean;

  constructor() {
  }

  ngOnChanges(): void {
    if (!this.entityLeadTime() || !this.configurationLeadTime()) {
      this.validLeadTime = false;
    } else {
      this.validLeadTime = this.entityLeadTime().leadTimeDays >= this.configurationLeadTime().leadTimeDays;
    }
  }

}
